import tablesort from 'tablesort'

document.addEventListener('turbo:load', () => {
  const tables = document.querySelectorAll('.js-tablesort')
  tables.forEach((table) => {
    tablesort(table)
  })
})
